<div class="h-100 w-100 padt-5 container-scans cursor">
    <div class="vehicle-profile-header widget-title">{{widgetData?.title}}</div>
    <div class="low-battery-count">
        <div class="d-flex align-items-center">
            <div class="patient-count-value ml-auto">05</div>
            <div class="ml-auto low-battery-alert-count-tile-size">
                <img src="../../../../assets/images/down arrow.svg" class="h-38" alt="up-arrow">
            </div>
        </div>
    </div>
</div>
